var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMultipleUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 15C12.1923 15 12.869 14.7947 13.4446 14.4101C14.0202 14.0254 14.4688 13.4787 14.7337 12.8391C14.9986 12.1995 15.0678 11.4957 14.9327 10.8167C14.7975 10.1377 14.464 9.51411 13.9744 9.02467C13.4848 8.53524 12.861 8.202 12.182 8.0671C11.503 7.93219 10.7992 8.00169 10.1597 8.26679C9.5202 8.5319 8.97366 8.9807 8.58923 9.55644C8.2048 10.1322 7.99975 10.809 8 11.5013C8.00034 12.4293 8.36924 13.3192 9.02558 13.9753C9.68192 14.6314 10.572 15 11.5 15Z",
    stroke: "currentColor",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 23.5V23.2166V23.1996C6 21.688 6.63214 20.2383 7.75736 19.1694C8.88258 18.1005 10.4087 17.5 12 17.5C13.5913 17.5 15.1174 18.1005 16.2426 19.1694C17.3679 20.2383 18 21.688 18 23.1996V23.2638V23.4988",
    stroke: "currentColor",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26 23.4988V23.2638V23.1996C26 21.688 25.3679 20.2383 24.2426 19.1694C23.1174 18.1005 21.5913 17.5 20 17.5C19.4896 17.5 18.9859 17.5618 18.5 17.681",
    stroke: "currentColor",
    strokeOpacity: 0.7,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 15C20.9945 15 21.4779 14.8534 21.889 14.5786C22.3002 14.3039 22.6206 13.9134 22.8098 13.4565C22.999 12.9996 23.0484 12.4969 22.9519 12.0119C22.8554 11.527 22.6172 11.0815 22.2674 10.7319C21.9177 10.3823 21.4722 10.1443 20.9872 10.0479C20.5021 9.95157 19.9995 10.0012 19.5427 10.1906C19.0859 10.3799 18.6955 10.7005 18.4209 11.1117C18.1463 11.523 17.9998 12.0064 18 12.5009C18.0002 13.1638 18.2637 13.7994 18.7326 14.2681C19.2014 14.7367 19.8371 15 20.5 15Z",
    stroke: "currentColor",
    strokeOpacity: 0.7,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultipleUser);
export default __webpack_public_path__ + "static/media/multiple-user.a9db251c000f917270a908ebec6d00a2.svg";
export { ForwardRef as ReactComponent };